export const mockRecommendationsReturn = [
  { itemId: '677ec597676e826f0e573a74', name: 'chocolate', score: 0.9 },
  { itemId: '677ec597676e826f0e573a74', name: 'chocolate', score: 0.9 },
  { itemId: '677ec597676e826f0e573a74', name: 'chocolate', score: 0.9 },
  //Add more later
];
